import {MAX_MULTI_FLIGHTS_SEGMENTS, DEFAULT_CABIN_CLASS_INDEX} from '../flights-routes';

export default function FlightsSearchFormController(
    $scope,
    $state,
    settingsCabinClasses,
    flightsFactory,
    flightsUtils,
    l10nService,
    timeSlots,
    authService,
) {
    'ngInject';

    const vm = this;
    let allAirportsLabel;
    Object.assign(vm, {
        $onInit,
    });

    Object.assign($scope, {
        addTicketSearchSegment,
        removeFlightSearchGroup,
        isAddFlightsEnabled,
    });

    function $onInit() {
        allAirportsLabel = l10nService.localize('All Airports');
        getFrequentFlights();
    }

    $scope.locationPlaceholder = l10nService.localize('City or Airport...');
    $scope.moreOptionsTemplate = 'app/modules/flights/directives/templates/moreOptions.tmpl.html';
    $scope.travellersTemplate = 'app/modules/flights/directives/templates/travellers.tmpl.html';

    const _Adult = flightsFactory.params.Travelers.Adult.value;
    const _Infant = flightsFactory.params.Travelers.Infant.value;
    const _Child = flightsFactory.params.Travelers.Child.value;
    const _Class = flightsFactory.params.CabinClass;
    const _MaxTravellerAmount = authService.getAvailableServicesFromSessionStorage().MaxTravelerAmount;

    $scope.module = flightsFactory.getModule();
    $scope.isFlights = flightsFactory.isFlights();
    $scope.isTrains = flightsFactory.isTrains();

    $scope.$state = $state;
    $scope.params = flightsFactory.params;
    $scope.options = flightsFactory.options;
    $scope.options.time = flightsFactory.getTimeOptions(timeSlots);

    $scope.options.cabinClasses = prepareCabinClassesOptions(settingsCabinClasses);
    $scope.options.adults = flightsUtils.makeTravellersOptions('Adult', _MaxTravellerAmount ? Math.min(_MaxTravellerAmount, 4) : 4, false);
    $scope.options.infants = flightsUtils.makeTravellersOptions('Infant', _Adult, true);
    $scope.options.children = flightsUtils.makeTravellersOptions('Child', 4 - _Adult, true);
    $scope.options.isChildrenAllowed = !_MaxTravellerAmount;
    $scope.options.time0 = angular.copy($scope.options.time);
    $scope.options.time1 = angular.copy($scope.options.time);
    $scope.options.time2 = angular.copy($scope.options.time);
    $scope.options.time3 = angular.copy($scope.options.time);

    $scope.frequentFlights = [];
    $scope.options.type = [
        {text: l10nService.localize('Leaving by'), value: 'false'}, {text: l10nService.localize('Arriving by'), value: 'true'},
    ];

    $scope.getFrequentFlightView = getFrequentFlightView;
    $scope.setSelectedFrequentFlight = setSelectedFrequentFlight;

    $scope.params.CabinClass = angular.copy(_Class || $scope.options.cabinClasses[1]);
    $scope.params.Travelers.Adult = angular.copy(_.find($scope.options.adults, {value: _Adult.toString()}));
    $scope.params.Travelers.Infant = angular.copy(_.find($scope.options.infants, {value: _Infant.toString()}));
    $scope.params.Travelers.Child = angular.copy(_.find($scope.options.children, {value: _Child.toString()}));

    initTimeOptions();

    function initTimeOptions() {
        $scope.params.TicketSearchSegments.forEach((searchSegment) => {
             searchSegment._time = angular.copy(searchSegment._time || $scope.options.time[0]);
        });
    }

    function isAddFlightsEnabled() {
        return $scope.params.TicketSearchSegments.length < MAX_MULTI_FLIGHTS_SEGMENTS;
    }

    function addTicketSearchSegment() {
        if ($scope.params.TicketSearchSegments.length >= MAX_MULTI_FLIGHTS_SEGMENTS) {
            return;
        }

        const segment = {
            _time: angular.copy($scope.options.time[0]),
            _isArrivalTime: false,
            cabinClass: angular.copy($scope.options.cabinClasses[DEFAULT_CABIN_CLASS_INDEX]),
        };
        $scope.params.TicketSearchSegments.push(segment);
    }

    function removeFlightSearchGroup(index) {
        $scope.params.TicketSearchSegments.splice(index, 1);
    }

    function getFrequentFlights() {
        flightsFactory.getFrequentFlights()
            .then((flights) => $scope.frequentFlights = flights);
    }

    function getFrequentFlightView(flight) {
        const airportName = (flight.AirportName)
            ? flight.AirportName
            : getFrequentFlightAllLocationName();

        return _.template('{{cityName}}, {{countryCode}} - {{airportName}} ({{airportCode}})')({
            cityName: flight.CityName,
            countryCode: flight.CountryCode,
            airportName,
            airportCode: flight.AirportCode,
        });
    }

    function setSelectedFrequentFlight(model, field, viewModel) {
        return function(flight) {
            viewModel.$setValidity('editable', true);
            const name = flight.CityName + ', ' + flight.CountryCode;
            const airport = flight.AirportName ? flight.AirportName : getFrequentFlightAllLocationName();
            const Code = flight.AirportCode;
            const DisplayString = name + ' - ' + airport + ' (' + flight.AirportCode + ')';
            const RailStationCode = flight.RailStationCode;

            model[field] = {
                name,
                airport,
                Code,
                DisplayString,
                IsCity: flight.IsCity,
                RailStationCode,
            };
        };
    }

    function getFrequentFlightAllLocationName() {
        return allAirportsLabel;
    }

    function prepareCabinClassesOptions(cabinClasses) {
        return _.map(cabinClasses, function(cabinClass) {
            return {text: cabinClass.ClassName, value: cabinClass.Id};
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/controllers/flightsSearchFormCtrl.js